import { datadogRum } from '@datadog/browser-rum'
import { PROD } from '@frame/index'
import { useStore } from '@frame/lib/stores/useStore'
import { version } from '@script/index'

export enum Events {
  InternalError = 'InternalError',

  Initialized = 'Initialized',
  RequestedClose = 'RequestedClose',
  DeclinedClose = 'DeclinedClose',
  Closed = 'Closed',
  StepViewed = 'StepViewed',
  CredentialsPartnerEvent = 'CredentialsPartnerEvent',
  Opened = 'Opened',
  Completed = 'Completed',
  Closing = 'Closing',
  Error = 'Error',
  ClickBankIncomeStream = 'ClickBankIncomeStream',
}

export function track(event: Events, traits: Record<string, unknown> = {}) {
  const { session: _session, config } = useStore.getState()
  const props: Record<string, unknown> = {
    ...traits,
    version,
    sessionId: config?.sessionToken,
    publishable_key: config?.publishableKey,
  }

  if (PROD) {
    datadogRum.addAction(event, props)
  } else {
    console.debug(`tracking.track: ${event}`, props) // eslint-disable-line no-console
  }
}

export function trackView(name: string) {
  // Calling startView with the same name twice in a row will trigger a new view, so we deduplicate these calls to avoid
  // recording a new view every time that the view is rendered.

  const previousViewName = datadogRum.getInternalContext()?.view?.name

  if (previousViewName === name) {
    return
  }

  datadogRum.startView({
    name,
  })
}
